import {
  createPlugin,
  createComponentExtension
} from '@backstage/core-plugin-api';

export const amplitudeAnalyticsPlugin = createPlugin({
  id: 'amplitude-analytics',
});

export const AmplitudeAnalytics = amplitudeAnalyticsPlugin.provide(
  createComponentExtension({
    name: 'AmplitudeAnalytics',
    component: {
      lazy: () => import('./components/AmplitudeAnalyticsComponent').then(m => m.AmplitudeAnalyticsComponent),
    },
  }),
);
